module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA5UExURUdwTBZs9hVq9hFl8hds9Rdr9RVq+Bds9hdq9Bds9Rdr9hdr9RVr9RZq9Rdr9hJn9hdr9Rds9hhs9e2JXhgAAAASdFJOUwBwQA6w6SuGYPp5gVNpjRvZl6U80DQAAADDSURBVCjPrZLZFoMgDERlJ+zk/z+2sUdLpNSHHucJuTITSLbtGSmZoyPFLNXMbGnI1IrlNNKW0SX7lHwu2iCCGFQihMvvNgJadjjMaYFtOfQz9uj+xFbd4QT6BifYv35homKV3Y0d9BsXJH7ShblGI066yu708uLm3mU0Ylm5Wr5aYOtDHUdHK4C8UglQ+ThA5pRucGlxANSfYKVpPCY3g+2YD9vQyLmWSkfe9WduxOQQu9qN43rSKcCYhfEIANB1e0wvQWoKppo+IbkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/more11.png
// module id = v+qp
// module chunks = 0